export default "__VITE_ASSET__CwggViUp__"